import { render, staticRenderFns } from "./SearchOriginalDocuments.vue?vue&type=template&id=5a75fa94&scoped=true"
import script from "./SearchOriginalDocuments.vue?vue&type=script&lang=js"
export * from "./SearchOriginalDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a75fa94",
  null
  
)

export default component.exports